import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './AuthService';
import { PermissionsService } from './Permissions';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private permissions: PermissionsService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {
      const user = await this.authService.getCurrentUser(); 

      if (user) {
      
        if (state.url === '/login' || state.url === '/') {
          this.router.navigate(['/attendance']);
          return false;
        }

      
        if (route.data['requiresVenueAdmin']) {
          await this.permissions.checkPermissions(); 
          const isVenueAdmin = this.permissions.venueAdminSubject.getValue();
          
          if (!isVenueAdmin) {
            this.router.navigate(['/attendance']);
            return false;
          }
        }

        if (route.data['requiresDeliveryAdmin']) {
          await this.permissions.checkPermissions(); 
          const isDeliveryAdmin = this.permissions.deliveryAdminSubject.getValue();
          
          if (!isDeliveryAdmin) {
            this.router.navigate(['/attendance']);
            return false;
          }
        }

        if (route.data['requiresTicketmasterOnly']) {
          await this.permissions.checkPermissions();
          const isTicketmaster = this.permissions.ticketmasterSubject.getValue();

          if (!isTicketmaster) {
            this.router.navigate(['/attendance']);
            return false;
          }
        }

        if (route.data['requiresGlobalAdmin']) {
          await this.permissions.checkPermissions();
          const isGlobalAdmin = this.permissions.globalAdminSubject.getValue();

          if (!isGlobalAdmin) {
            this.router.navigate(['/attendance']);
            return false;
          }
        }

        if (route.data['requiresAdmin'] || route.data['requiresTicketmaster']) {
          await this.permissions.checkPermissions();
          const isTicketmaster = this.permissions.ticketmasterSubject.getValue();
          const isAdmin = this.permissions.adminSubject.getValue();
          const hasScan = this.permissions.scanSubject.getValue();

          if (!isTicketmaster && !isAdmin && !hasScan) {
            this.router.navigate(['/attendance']);
            return false;
          }
        }

        return true; 
      } else {
      
        if (state.url !== '/login') {
          this.router.navigate(['/login']);
          return false;
        }
        return true;
      }
    } catch (error) {
     
      if (state.url !== '/login') {
        this.router.navigate(['/login']);
        return false;
      }
      return true;
    }
  }
}
